module.exports = "<div users-wrapper page-class=\"users-login\">\n  <div md-whiteframe=\"1\" class=\"content-box text-center\">\n    <h1>{{ \"USERS.PASSWORD_CHANGED.TITLE\" | translate:{name: email} }}</h1>\n    <p>{{ \"USERS.PASSWORD_CHANGED.LEAD\" | translate }}</p>\n\n    <!-- <div>\n      <img class=\"round\" alt=\"F&F\" src=\"http://placehold.it/200x200\">\n    </div> -->\n\n    <a class=\"md-button md-raised md-primary\" ui-sref=\"public.users.start\">\n        {{ \"USERS.PASSWORD_CHANGED.GO_TO_ACCOUNT\" | translate }}</a>\n\n\n  </div>\n</div>\n\n";


//////////////////
// WEBPACK FOOTER
// ./src/users/forgot-password/password-changed.html
// module id = 249
// module chunks = 0